<template>
  <g>
    <g transform="scale(0.3)">
        <text transform="matrix(1 0 0 1 10 10)" class="name"
            >온도센서{{ number }}</text
        >
        <g>
            <path class="st0" d="M142,306c-5.51,0-10-4.49-10-10V193.62h-19V296c0,5.51-4.49,10-10,10s-10-4.49-10-10V193.62H73V296
                c0,5.51-4.49,10-10,10s-10-4.49-10-10V193.62H32.08v-130h0.55C36.85,48.26,65.9,37,102.58,37s65.73,11.26,69.95,26.62h0.49l0.05,3
                v127H152V296C152,301.51,147.51,306,142,306z"/>
        </g>
        <g style="transform: translate(8px,0px)">
            <defs>
                <path id="SVGID_1_TMP" d="M56.01,179.39v116.5c0,3.9,3.17,7.07,7.07,7.07c3.91,0,7.07-3.17,7.07-7.07v-116.5
                    c0-3.9-3.17-7.07-7.07-7.07C59.18,172.32,56.01,175.49,56.01,179.39"/>
            </defs>
            <clipPath id="SVGID_2_TMP">
                <use xlink:href="#SVGID_1_TMP"  style="overflow:visible;"/>
            </clipPath>
                <linearGradient id="SVGID_3_TMP" gradientUnits="userSpaceOnUse" x1="559.978" y1="990.8287" x2="561.5113" y2="990.8287" gradientTransform="matrix(9.2244 0 0 -9.2244 -5109.4731 9377.4746)">
                <stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="1.868181e-08" style="stop-color:#EDEDED"/>
                <stop  offset="5.778537e-08" style="stop-color:#CECECE"/>
                <stop  offset="1.020836e-07" style="stop-color:#B2B2B2"/>
                <stop  offset="1.521744e-07" style="stop-color:#9C9C9C"/>
                <stop  offset="2.106338e-07" style="stop-color:#8B8B8B"/>
                <stop  offset="2.829549e-07" style="stop-color:#808080"/>
                <stop  offset="3.843946e-07" style="stop-color:#797979"/>
                <stop  offset="6.659740e-07" style="stop-color:#777777"/>
                <stop  offset="0.1253" style="stop-color:#848484"/>
                <stop  offset="0.4162" style="stop-color:#9F9FA0"/>
                <stop  offset="0.6113" style="stop-color:#9C9C9D"/>
                <stop  offset="0.7532" style="stop-color:#939394"/>
                <stop  offset="0.8778" style="stop-color:#848384"/>
                <stop  offset="0.9926" style="stop-color:#6F6E6E"/>
                <stop  offset="1" style="stop-color:#6D6C6C"/>
            </linearGradient>
            <g class="pin">
                <rect x="56.01" y="172.32" class="st1" width="14.14" height="130.64"/>
                <rect
                    :id="`${pincode}PS`"
                    @click="onClick(`${pincode}PS`)"
                    class="pin-cover terminal snap"
                    x="49"
                    y="290"
                    width="35"
                    height="35"
                />
            </g>
        </g>
        <g style="transform: translate(-11px,0px)">
            <defs>
                <path id="SVGID_4_TMP" d="M135.01,179.39v116.5c0,3.9,3.17,7.07,7.07,7.07c3.91,0,7.07-3.17,7.07-7.07v-116.5
                    c0-3.9-3.17-7.07-7.07-7.07C138.18,172.32,135.01,175.49,135.01,179.39"/>
            </defs>
            <clipPath id="SVGID_5_TMP">
                <use xlink:href="#SVGID_4_TMP"  style="overflow:visible;"/>
            </clipPath>
                <linearGradient id="SVGID_6_TMP" gradientUnits="userSpaceOnUse" x1="568.5422" y1="990.8287" x2="570.0755" y2="990.8287" gradientTransform="matrix(9.2244 0 0 -9.2244 -5109.4731 9377.4746)">
                <stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="1.868181e-08" style="stop-color:#EDEDED"/>
                <stop  offset="5.778537e-08" style="stop-color:#CECECE"/>
                <stop  offset="1.020836e-07" style="stop-color:#B2B2B2"/>
                <stop  offset="1.521744e-07" style="stop-color:#9C9C9C"/>
                <stop  offset="2.106338e-07" style="stop-color:#8B8B8B"/>
                <stop  offset="2.829549e-07" style="stop-color:#808080"/>
                <stop  offset="3.843946e-07" style="stop-color:#797979"/>
                <stop  offset="6.659740e-07" style="stop-color:#777777"/>
                <stop  offset="0.1253" style="stop-color:#848484"/>
                <stop  offset="0.4162" style="stop-color:#9F9FA0"/>
                <stop  offset="0.6113" style="stop-color:#9C9C9D"/>
                <stop  offset="0.7532" style="stop-color:#939394"/>
                <stop  offset="0.8778" style="stop-color:#848384"/>
                <stop  offset="0.9926" style="stop-color:#6F6E6E"/>
                <stop  offset="1" style="stop-color:#6D6C6C"/>
            </linearGradient>
            <g class="pin">
                <rect x="135.01" y="172.32" class="st2" width="14.14" height="130.64"/>
                <rect
                    :id="`${pincode}MS`"
                    @click="onClick(`${pincode}MS`)"
                    class="pin-cover terminal snap"
                    x="129"
                    y="290"
                    width="35"
                    height="35"
                />
            </g>
        </g>
        <linearGradient id="SVGID_10_TMP" gradientUnits="userSpaceOnUse" x1="102.5797" y1="95" x2="102.5797" y2="40">
            <stop  offset="0" style="stop-color:#FFFFFF"/>
            <stop  offset="1" style="stop-color:#1A1A1A"/>
        </linearGradient>
        <g class="st7">
            <ellipse class="st4" cx="102.58" cy="67.5" rx="67.5" ry="27.5"/>
            <rect x="35.08" y="66.62" class="st5" width="135" height="124"/>
        </g>
        <g>
            <path class="st6" d="M73.82,118.08h15.32v3.35H73.82V118.08z M79.74,119.83h3.49v19.56h-3.49V119.83z"/>
            <path class="st6" d="M106.13,118.08h4.04v21.3h-3.28v-16.25l0.15,0.94l-4.66,12.64h-2.81l-4.66-12.35l0.15-1.23v16.25h-3.28v-21.3
                h4.04l5.16,14.21L106.13,118.08z"/>
            <path class="st6" d="M115.16,118.08h3.5v21.3h-3.5V118.08z M116.84,127.77h6.81c0.57,0,1.06-0.13,1.49-0.39s0.76-0.63,1-1.11
                s0.36-1.03,0.36-1.66c0-0.63-0.12-1.19-0.35-1.67s-0.57-0.85-1-1.11s-0.93-0.4-1.49-0.4h-6.81v-3.35h6.71
                c1.3,0,2.44,0.27,3.43,0.81s1.75,1.31,2.3,2.29s0.82,2.13,0.82,3.43s-0.27,2.44-0.82,3.42s-1.31,1.74-2.3,2.28
                s-2.13,0.81-3.43,0.81h-6.71V127.77z"/>
        </g>
        <!--slider-->
        <g
            id="range-slider"
            style="transform: rotate(-90deg) translate(-135px, -90px) scale(1.2)"
            @click="initController"
        >
            <g :class="{'range-hide': !on || isSensorDataUploaded }">
                <g class="slider-icon">
                    <g
                        style="transform: rotate(90deg) translate(-55px, -230px);"
                    >
                        <path
                            style="transform: scale(3.5)"
                            d="M12 9.312l-1.762.491 1.562.881-.491.871-1.562-.881.491 1.762-.963.268-.76-2.724-2.015-1.126v1.939l2 2-.707.707-1.293-1.293v1.793h-1v-1.793l-1.293 1.293-.707-.707 2-2v-1.939l-2.015 1.126-.761 2.724-.963-.268.491-1.762-1.562.882-.491-.871 1.562-.881-1.761-.492.269-.962 2.725.76 1.982-1.11-1.983-1.109-2.724.759-.269-.962 1.762-.491-1.563-.882.491-.871 1.562.881-.49-1.762.963-.269.76 2.725 2.015 1.128v-1.94l-2-2 .707-.707 1.293 1.293v-1.793h1v1.793l1.293-1.293.707.707-2 2v1.94l2.016-1.127.76-2.725.963.269-.492 1.761 1.562-.881.491.871-1.562.881 1.762.492-.269.962-2.725-.76-1.982 1.11 1.982 1.109 2.725-.76.269.963zm4-5.812v7.525c0 1.57-.514 2.288-1.41 3.049-1.011.859-1.59 2.107-1.59 3.426 0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5c0-1.319-.579-2.567-1.589-3.426-.897-.762-1.411-1.48-1.411-3.049v-7.525c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5zm5 0v7.525c0 .587.258 1.145.705 1.525 1.403 1.192 2.295 2.966 2.295 4.95 0 3.59-2.909 6.5-6.5 6.5s-6.5-2.91-6.5-6.5c0-1.984.892-3.758 2.295-4.949.447-.381.705-.94.705-1.526v-7.525c0-1.934 1.567-3.5 3.5-3.5s3.5 1.566 3.5 3.5zm0 14c0 1.934-1.567 3.5-3.5 3.5s-3.5-1.566-3.5-3.5c0-1.141.599-2.084 1.393-2.781 1.01-.889 1.607-1.737 1.607-3.221v-.498h1v.498c0 1.486.595 2.33 1.607 3.221.794.697 1.393 1.64 1.393 2.781z"
                        />
                    </g>
                    <g
                        style="transform: rotate(90deg) translate(260px, -230px);"
                    >
                        <path
                            style="transform: scale(3.5)"
                            d="M17.5 2c.827 0 1.5.673 1.5 1.5v7.525c0 1.569.514 2.287 1.411 3.05 1.01.858 1.589 2.106 1.589 3.425 0 2.481-2.019 4.5-4.5 4.5s-4.5-2.019-4.5-4.5c0-1.319.579-2.567 1.59-3.425.896-.761 1.41-1.479 1.41-3.05v-7.525c0-.827.673-1.5 1.5-1.5zm0-2c-1.933 0-3.5 1.567-3.5 3.5v7.525c0 .587-.258 1.146-.705 1.525-1.403 1.192-2.295 2.965-2.295 4.95 0 3.59 2.909 6.5 6.5 6.5s6.5-2.91 6.5-6.5c0-1.985-.892-3.758-2.295-4.95-.447-.38-.705-.938-.705-1.525v-7.525c0-1.933-1.567-3.5-3.5-3.5zm2.107 14.718c-1.012-.89-1.607-1.734-1.607-3.22v-6.498h-1v6.498c0 1.484-.597 2.332-1.607 3.22-.794.698-1.393 1.642-1.393 2.782 0 1.933 1.567 3.5 3.5 3.5s3.5-1.567 3.5-3.5c0-1.14-.599-2.083-1.393-2.782zm-13.107-8.718c1.379 0 2.5 1.122 2.5 2.5s-1.121 2.5-2.5 2.5-2.5-1.122-2.5-2.5 1.121-2.5 2.5-2.5zm0-1c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5-1.567-3.5-3.5-3.5zm-4.5 3.5c0-.171.032-.333.051-.5h-2.051v1h2.051c-.019-.167-.051-.329-.051-.5zm1.705-3.501l-1.448-1.449-.707.707 1.448 1.448c.21-.261.445-.497.707-.706zm6.297.706l1.447-1.448-.707-.707-1.448 1.448c.263.21.498.445.708.707zm-3.502-1.705c.171 0 .334.032.5.05v-2.05h-1v2.05c.166-.018.329-.05.5-.05zm0 9c-.171 0-.334-.032-.5-.05v2.05h1v-2.05c-.166.018-.329.05-.5.05zm4.449-5c.019.167.051.329.051.5l-.051.5h2.051v-1h-2.051zm-7.951 3.294l-1.448 1.449.707.707 1.448-1.448c-.262-.21-.497-.446-.707-.708zm6.296.708l1.448 1.448.707-.707-1.447-1.448c-.21.262-.445.497-.708.707z"
                        />
                    </g>
                </g>
                <g id="range-container">
                    <path
                        d="M174,257c-8.96,0-16.25-7.29-16.25-16.25v-169c0-8.96,7.29-16.25,16.25-16.25s16.25,7.29,16.25,16.25v169
                C190.25,249.71,182.96,257,174,257z M174,59.83c-6.57,0-11.92,5.35-11.92,11.92v169c0,6.57,5.35,11.92,11.92,11.92
                s11.92-5.35,11.92-11.92v-169C185.92,65.18,180.57,59.83,174,59.83z"
                    />
                </g>
                <circle
                    id="slider-pin"
                    :class="{ on: on && !isSensorDataUploaded }"
                    cx="174"
                    cy="75"
                    r="26"
                />
                <polygon
                    points="168.58,138.31 174,147.7 179.42,138.31 175.56,138.31 175.56,125.8 172.44,125.8 172.44,138.31 "
                />
            </g>
        </g>
        <!-- Sensor data -->
        <g v-if="on && $store.state.sim.userData[namecode] ">
          <text transform="matrix(1 0 0 1 10 -50)" class="value">
            값 : {{ value }}℃
          </text>
        </g>
    </g>
  </g>
</template>

<script>
import Vue from 'vue'
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

const map = function (val, a, b, c, d) {
  return ((val - a) / (b - a)) * (d - c) + c
}
var vm = new Vue({
  data: {
    range: {
      min: 0,
      max: 1024
    },
    draggable: []
  }
})

export default {
  props: ['data'],
  mixins: [pins],
  name: 'TSensor',
  data () {
    return {
      on: false,
      socket: null,
      temperature: 0,
      timemax: null,
      value: 0
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  computed: {
    isSensorDataUploaded () {
      return this.$store.state.sim.userData[this.namecode]
    }
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    initController (e) {
      if (this.on) {
        vm.draggable = window.Draggable.create(
        `#${this.data.id} #slider-pin`,
        {
          type: 'x,y',
          bounds: `#${this.data.id} #range-container`,
          lockAxis: true,
          onClick: function (e) {
            e.stopPropagation()
          },
          onDrag: () => {
            const y = vm.draggable[0].y
            window.gsap.set(vm.draggable[0].target, {
              onUpdate: vm.draggable[0].update
            })
            this.controller(y)
          }
        }
        )
      }
    },
    controller (val) {
      this.temperature = map(val, 6, 156, 0, 1023)
      this.$store.commit('socket/sendMessage', { socket: this.socket, message: { value: this.temperature } })
    },
    start (socket) {
      this.on = true
      this.socket = socket
      if (this.$store.state.sim.userData[this.namecode]) {
        this.socket.onmessage = ({ data }) => {
          data = JSON.parse(data)
          this.value = Math.round(map(data.value, 0, 1023, -50, 120) * 10) / 10
        }
      } else {
        window.Draggable.get(`#${this.data.id}`).disable()
        this.initController()
      }
    },
    off () {
      this.on = false
      this.value = 0
      if (!this.socket) {
        window.Draggable.get(`#${this.data.id}`).enable()
      } else this.socket = null
    }
  }
}
</script>

<style lang="scss" scoped>
.pin-cover {
  display: block;
  stroke: none;
  fill: none;
}
.pin:hover {
  cursor: pointer;
  .pin-cover {
    stroke-width: 8px;
    stroke: black;
    fill: #ff6f61;
  }
}
.selected {
  & rect.st1,
  & rect.st2,
  & .st7 {
    stroke: #ff6f61;
    stroke-width: 4px;
  }
}
.on {fill: #ff6f61;}
.name {font-size: 40px;}
.value {
  font-weight: 500;
  font-size: 48px;
}
.range-hide{fill: transparent;}
.st0{fill:transparent;}
.st1{clip-path:url(#SVGID_2_TMP);fill:url(#SVGID_3_TMP);}
.st2{clip-path:url(#SVGID_5_TMP);fill:url(#SVGID_6_TMP);}
.st4{fill:url(#SVGID_10_TMP);}
.st5{fill:#333333;}
.st6{fill:#FFFFFF;}
</style>
